import MdContent from 'components/md-content'

const __default__ = {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    title(){
      return this.data.title
    },
    stats () {
      return this.data.stats
    },
    info(){
      return this.data.info
    },
    loading(){
      return !this.stats
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'finances',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get MdContent() { return MdContent } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})